import { PhysicianActions } from 'src/redux/actions/constant';

const {
  GET_ALL_FACILITY_REQUEST,
  GET_ALL_FACILITY_SUCCESS,
  GET_ALL_FACILITY_LOADER,
  GET_ALL_FACILITY_FAILURE,
  GET_ALL_FACILITY_RESET,
} = PhysicianActions;

const intialFacilityState: any = {
  isGetFacilities: false,
  response: null,
  loading: false,
  totalFacility: [],
  currentPage: -1,
  pageNumber: 0,
};
export const getFacilityReducer = (state = intialFacilityState, action: any) => {
  switch (action.type) {
    case GET_ALL_FACILITY_SUCCESS: {
      const newPageNumber = action.payload?.data?.data?.number;
      if (state.currentPage + 1 === newPageNumber) {
        return {
          ...state,
          isGetFacilities: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalFacility: [...state.totalFacility, ...action.payload?.data?.data?.content],
          pageNumber: state.pageNumber + 1,
        };
      } else {
        return {
          ...state,
          isGetFacilities: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalFacility: action.payload?.data?.data?.content || [],
        };
      }
    }

    case GET_ALL_FACILITY_FAILURE:
      return {
        ...state,
        isGetFacilities: false,
        response: action.payload,
      };

    case GET_ALL_FACILITY_LOADER:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_FACILITY_RESET:
      return intialFacilityState;
    default:
      return state;
  }
};
